"use client";

import { useRef } from "react";
import Image from "next/image";
import { motion, useScroll, useTransform } from "framer-motion";
import ServicesHero from "./ServicesHero";
import ServicesList from "./ServicesList";

const sectionVariants = {
  hidden: { opacity: 0, y: 48 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] as [number, number, number, number] },
  },
};

export default function ServicesClient() {
  const { scrollYProgress } = useScroll();

  const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  return (
    <div className="relative min-h-screen">
      {/* ── Fixed Parallax Aesthetic Background ── */}
      <div className="pointer-events-none fixed inset-0 -z-10 h-[120vh] w-full overflow-hidden bg-[var(--background)]">
        <motion.div style={{ y: backgroundY }} className="absolute inset-0 h-full w-full will-change-transform backface-hidden">
          <Image
            src="https://images.unsplash.com/photo-1602178531863-d7e451a02d63?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Abstract Dark Aesthetic"
            fill
            sizes="100vw"
            className="object-cover opacity-30 md:opacity-40"
            priority
          />
        </motion.div>
        {/* Soft blackout gradients to blend smoothly with [var(--background)] */}
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--background)] via-[var(--background)]/70 to-[var(--background)]" />
      </div>

      <div className="relative z-10">
        <motion.div variants={sectionVariants} initial="hidden" animate="show">
          <ServicesHero />
        </motion.div>
        <ServicesList />
      </div>
    </div>
  );
}
